import { Operation, Authentication, Navigation } from '.';
import { ROUTES } from 'config';
import * as API from 'api'
import { Models } from 'fluent-forever-shared-types';
import { loadUserInformation } from './user';
import { emailConfirmedSuccess } from 'store/modules/authentication';
import { httpRequest } from './initialize';
/** Verify user clicked on email confirmation link  
 *  - Auth0 access token contains the email flag in meta data
 */
export const verify = (dispatch) => {
    console.debug('Verifying email...')
    //renew token => to get updated email confirmation flag
    return Authentication.renewAccessToken(dispatch)
        .then((renewResult) => {
            // Reload user to get updated information
            return loadUserInformation(dispatch).then((userResult: Models.IUserAccount) => {
                // redirect to home either way
                Navigation.redirectTo(dispatch, ROUTES.HOME)
                if (userResult && userResult.isPendingEmailConfirmation) {
                    //This Should Not Happen unless someone just came to this url without clicking email
                    Operation.onFail(`We still couldn't verify your email address.`, dispatch);
                    return false;
                } else {
                    dispatch(emailConfirmedSuccess(userResult.email))
                    Operation.onSuccess("Thank you for confirming your email.", dispatch);
                    return true;
                }
            })
        })
        .catch(err => Operation.onFail('Failed to verify email confirmation', dispatch, err));
}

/** Email Confirmation Resend */
export const reSend = (dispatch) => {
    return API.User.resendEmailConfirmation(httpRequest)
        .then(result => {
            if (result) {
                Operation.onSuccess('Confirmation email was re-sent to your email.', dispatch);
            }
            return result;
        })
        .catch(err => Operation.onFail('Failed to re-send confirmation email', dispatch, err));
}


// WEBPACK FOOTER //
// ./src/application/emailVerification.ts